var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"newDom2"}},[_c('video',{ref:"videoPlayer2",staticClass:"video-js vjs-big-play-centered",attrs:{"id":"videoPlayer2","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }